import { videoData } from "./data";
import Slider from "react-slick";
import { Quotes, Star } from "@phosphor-icons/react";

const CustomerFeedbackCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 800,
    arrows: false,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    customPaging: () => (
      <div className="h-2 w-2 rounded-full bg-gray-600 transition-all" />
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {videoData?.map((video, i) => (
        <div key={i} className="px-3">
          <div className="flex h-full flex-col rounded-2xl border border-white/[0.15] bg-gray-800/80 p-6 shadow-lg shadow-black/20 md:p-7">
            {/* Author info — top, prominent */}
            <div className="flex items-center gap-4">
              <img
                src={require(
                  `../../assets/speakers/${video.author.name.split(" ").join("-").trim().toLowerCase()}.jpg`
                )}
                className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-app-400/30 md:h-[72px] md:w-[72px]"
                alt={`${video.author.name}`}
              />
              <div>
                <h4 className="font-serif text-base font-semibold text-white md:text-lg">
                  {video.author.name}
                </h4>
                <p className="font-serif text-sm text-gray-400">
                  {video.author.designation}
                </p>
                <p className="font-serif text-sm font-medium text-app-300">
                  {video.author.company}
                </p>
              </div>
            </div>

            {/* Stars */}
            <div className="mt-4 flex gap-1">
              {[...Array(5)].map((_, j) => (
                <Star
                  key={j}
                  size={16}
                  weight="fill"
                  className="text-yellow-400"
                />
              ))}
            </div>

            {/* Quote */}
            <div className="relative mt-3">
              <Quotes
                size={32}
                weight="fill"
                className="absolute -left-1 -top-1 text-app-400/20"
              />
              <p className="pl-7 font-serif text-sm leading-relaxed text-gray-200 md:text-base md:leading-7">
                {video.testimonial}
              </p>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default CustomerFeedbackCarousel;
